/**
 * Shared area-under-line gradient for Chart.js (climate / water device cards).
 */

export function parseChartColorToRgb(input) {
  if (!input || typeof input !== 'string') return { r: 100, g: 150, b: 200 };
  const s = input.trim();
  if (s.startsWith('#')) {
    let h = s.slice(1);
    if (h.length === 3) {
      h = h
        .split('')
        .map((c) => c + c)
        .join('');
    }
    const n = parseInt(h, 16);
    if (!Number.isFinite(n) || h.length !== 6) return { r: 100, g: 150, b: 200 };
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }
  const m = s.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (m) {
    return { r: Number(m[1]), g: Number(m[2]), b: Number(m[3]) };
  }
  return { r: 100, g: 150, b: 200 };
}

/**
 * Vertical fill under the line: stronger under the curve, fading toward the bottom.
 */
export function buildChartAreaGradient(context, color) {
  const { chart } = context;
  const { ctx, chartArea } = chart;
  const { r, g, b } = parseChartColorToRgb(color);
  if (!chartArea) {
    return `rgba(${r},${g},${b},0.14)`;
  }
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
  gradient.addColorStop(0, `rgba(${r},${g},${b},0.34)`);
  gradient.addColorStop(0.38, `rgba(${r},${g},${b},0.14)`);
  gradient.addColorStop(1, `rgba(${r},${g},${b},0.02)`);
  return gradient;
}
